import { ReactComponent as CursorIcon } from '@assets/components/gauge/AzmElv-cursor.svg';
import { Box, Center, Icon } from '@chakra-ui/react';
import { getPositionOnCircle } from '@utils/sensors/camera/gauge.utils';
import { memo } from 'react';

type Props = {
  tilt: number;
  fov: number;
};

function ElevationCompassValue({ tilt, fov }: Readonly<Props>) {
  const markerPosition = getPositionOnCircle(-tilt, 148, { x: 148, y: 148 }, 0);

  const startAngle = -tilt + 90 - fov / 2;

  return (
    <Center position="absolute" width="100%" height="100%" top={0}>
      <Box
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="100%"
        borderRadius="50%"
        background={`conic-gradient(
          from ${startAngle}deg,
          skyBlue ${fov}deg,
          transparent ${fov}deg ${startAngle}deg
        )`}
        pointerEvents="none"
        mask={`radial-gradient(circle closest-side,
            transparent 0px,
            transparent calc(100% - 30px),
            black calc(100% - 30px),
            black calc(100% - 3px),
            transparent calc(100% - 2px),
            transparent 100%)
          `}
        zIndex={2}
      />
      <Icon
        as={CursorIcon}
        position="absolute"
        width="18px"
        height="29px"
        zIndex={3}
        transform={`translate(-50%, -50%) rotate(${90 - tilt}deg)`}
        top={`${markerPosition.y}px`}
        left={`${markerPosition.x}px`}
      />
    </Center>
  );
}

export default memo(ElevationCompassValue);
